
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`La petite histoire`}</em></p>
    <p>{`Une collaboration a été mise en place avec Tesla, pour créer des
mini-entreprises et déployer ainsi le vaccin dans le monde entier.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;